import { useMemo } from "react"
import { useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { useConfig } from "src/hooks"
import type { ListingDescriptionFields } from "../components/listingDescriptionForm/listingDescription.fields"
import { listingDescriptionFieldNames } from "../components/listingDescriptionForm/listingDescription.fields"
import { listingDescriptionFieldMessages } from "./listingDescriptionField.messages"

export const useListingDescriptionFields = (isDraft: boolean): ListingDescriptionFields => {
	const { formatMessage } = useIntl()
	const { carSalesLiteEnabled } = useConfig()

	const fields = useMemo((): ListingDescriptionFields => {
		return {
			listingDescription: {
				debounced: isDraft ? 500 : undefined,
				descriptionText: formatMessage(listingDescriptionFieldMessages.listingDescriptionDescription),
				disabledHint: carSalesLiteEnabled
					? formatMessage(commonMessages.notAvailableInCarsalesLite)
					: undefined,
				label: formatMessage(listingDescriptionFieldMessages.listingDescriptionLabel),
				name: listingDescriptionFieldNames.listingDescriptionName,
			},
		}
	}, [formatMessage, isDraft, carSalesLiteEnabled])

	return fields
}
